import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { useParams } from "react-router-dom";
import './IpoDetailsNew.css'
import ipoprofileimg from "../../../Images/ipo/ksh-profile.png"
import ipopdfimg from "../../../Images/ipo/ipo-pdf.svg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { format, parseISO } from 'date-fns';
import axios from "axios";
import { ApiUrlDomain } from "../../Configration/Configrationnew";
import { useDispatch } from 'react-redux';
import { useCookies } from "react-cookie";
import { setState } from '../../features/User/UserSlice';
import TrackApi from "../../Activity_Track/TrackApi";
import Swal from "sweetalert2";


function IpoDetailsNew() {
    const EyeSlash = <FontAwesomeIcon icon={faEyeSlash} />
    const Eye = <FontAwesomeIcon icon={faEye} />
    const [showOtp, setShowOtp] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [data, setData] = useState([]);
    const [datatwo, setDatatwo] = useState([]);
    const [Datathree, setDatathree] = useState([]);
    const [Datafour, setDatafour] = useState([]);
    const [Datafive, setDatafive] = useState([]);
    const [Datasix, setDatasix] = useState([]);
    const { getCompName, getcocode } = useParams();
    const [dataGroup, setDataGroup] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDatatwo, getDataGroup, getDatathree, getDatafour, getDatafive, getDatasix;
    const [items, setItems] = useState([]);
    const [comanyname, setcomanyname] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    let PageSize = 8;
    const [mobNumber, setMobNumber] = useState('');
    const [otpfieldenable, setotpfieldenable] = useState(false);
    const [newUserMoberror, setNewUserMoberror] = useState('');
    const [otpis1, setotpis1] = useState('');
    const [otpis2, setotpis2] = useState('');
    const [otpis3, setotpis3] = useState('');
    const [otpis4, setotpis4] = useState('');
    const [newmobotpverify, Setnewmobotpverify] = useState(false);
    const [seconds, setSeconds] = useState(30);
    const [resendDisabled, setResendDisabled] = useState(true);
    const [verifyloader, setverifyloader] = useState(false);
    const dispatch = useDispatch();
    const [cookies, setCookie] = useCookies(['LeadId']);
    const [isGoogleLoginOpened, setisGoogleLoginOpened] = useState(true);
    const [mobile_l, setMobile_l] = useState('');
    const [showmobile, setshowmobile] = useState(false);
    //const [rhplink, setRhplink] = useState("");


    const formatDate = (date) => {
        return date != null ? format(parseISO(date), 'dd-MMM-yyyy') : '';
    };

     const downloadPdf = (e) => {
    //console.log("rhplink======",data[0].rhplink)
    e.preventDefault(); 
    if (data[0].rhplink) {
        window.open(data[0].rhplink, '_blank'); 
    } else {
        //console.log("data:", data); 
        alert("PDF link is not available.");
    }
};


    // Function to check if the date is today or in the past
    const isPastOrPresent = (date) => {
        const currentDate = new Date();
        const eventDate = parseISO(date);
        return eventDate <= currentDate;
    };

    useEffect(() => {
        if (getcocode != "") {
            const getUrl = BaseURL + "Iposynopsis";
           // console.log("getUrl==============" + `${getUrl}/1/${getcocode}`)
            fetch(`${getUrl}/1/${getcocode}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/2/${getcocode}`)
                .then((response) => response.json())
                .then((datatwo) => {
                    getDatatwo = datatwo.data;
                    setDatatwo(getDatatwo);
                })
                .catch((error) => {
                });


            fetch(`${getUrl}/3/${getcocode}`)
                .then((response) => response.json())
                .then((datathree) => {
                    getDatathree = datathree.data;
                    setDatathree(getDatathree);
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/4/${getcocode}`)
                .then((response) => response.json())
                .then((datafour) => {
                    getDatafour = datafour.data;
                    setDatafour(getDatafour);
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/5/${getcocode}`)
                .then((response) => response.json())
                .then((datafive) => {
                    getDatafive = datafive.data;
                    setDatafive(getDatafive);
                })
                .catch((error) => {
                });

            fetch(`${getUrl}/6/${getcocode}`)
                .then((response) => response.json())
                .then((datasix) => {
                    getDatasix = datasix.data;
                    setDatasix(getDatasix);
                })
                .catch((error) => {
                });

            const getUrlGroup = BaseURL + "GroupMaster";
            fetch(`${getUrlGroup}`)
                .then((response) => response.json())
                .then((dataG) => {
                    getDataGroup = dataG.data;
                    setDataGroup(getDataGroup);
                })
                .catch((error) => {
                });
        }
    }, [getcocode]);

    useEffect(() => {
        if (!data || data.length === 0) return;
        if (!Datafour || Datafour.length === 0) return;
        const safeDate = (date) => {
            if (!date) return "";
            return format(parseISO(date), "dd-MMM-yyyy");
        };
        const formattedItems = [
            { data: "Open Date", value: safeDate(data[0].OPENDATE) },
            { data: "Close Date", value: safeDate(data[0].CLOSDATE) },
            { data: "Listing Date", value: safeDate(data[0].listdate) },
            { data: "IPO Price Range", value: `₹ ${data[0].ISSUEPRICE} to ₹ ${data[0].IssuePri2}` },
            { data: "IPO Size", value: `₹ ${data[0].issuesize} Cr` },
            
            {
                data: "Listing Exchange",
                value: `${Datafour?.[0]?.LISTING || ""} ${Datafour?.[1]?.LISTING || ""}`
            },
        ].filter(item => item.value);
        setItems(formattedItems);
        setcomanyname(data[0].lname);
        setActiveIndex(0);
    }, [data, Datafour]);


    useEffect(() => {
        if (items.length === 0) return;
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) =>
                prevIndex === items.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);
        return () => clearInterval(interval);
    }, [items]);

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    const loginwithemailnewflow = () => {
        //console.log("mobile no===", mobNumber)
        if (mobNumber != "" && mobNumber.toString().length === 10) {
            axios.get(`${ApiUrlDomain}/otpSend?phone_no=${mobNumber}`).then((res) => {
                if (res.data == 'OTP sent successfully') {
                    setotpis1('')
                    setotpis2('')
                    setotpis3('')
                    setotpis4('')
                    setisGoogleLoginOpened(false);
                    Setnewmobotpverify(true);
                    setshowmobile(false);
                    setSeconds(30);
                    setResendDisabled(true);
                }
            }).catch((error) => {
                console.log(error);
            })
        }
        else {
            setNewUserMoberror("Please enter valid mobile number");
            return false;
        }
    }

    const handleNewUserMobileNumber = event => {
        const re = /^[0-9\b]+$/;
        setMobile_l(event.target.value.length);
        if (event.target.value.length <= 10 && re.test(event.target.value)) {
            setMobNumber(parseInt(event.target.value));
        }
        if (event.target.value.length == 0) {
            setMobNumber("");
        } setNewUserMoberror("");
    };

    const NewsignFlow = () => {
        const fullOtp = otpis1 + otpis2 + otpis3 + otpis4;
        setverifyloader(true);
        axios.get(`${ApiUrlDomain}/otpValidate?phone_no=${mobNumber}&otp=${fullOtp}`).then((res) => {
            if (res.data == 'OTP validated successfully') {
                setotpis1('');
                axios.post(`${ApiUrlDomain}/signupRetriveLead`, { "phone": mobNumber }).then((res) => {
                    if (res && res.data.length > 0) {
                        const leadId = res.data[0].prospectID;
                        setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                        const payloadData = {
                            "RelatedProspectId": leadId,
                            "ActivityNote": "Your Activity Note",
                            "mx_Custom_1": "Home",
                            "mx_Custom_2": "Your Activity Note",
                            "mx_CustomObject_81": window.location.href
                        }
                        TrackApi(payloadData);
                        if (res.data[0].prospectStage == "Customer" && res.data[0].mx_Lead_Status == "Active" && res.data[0].mx_Status == "Enabled") {
                            dispatch(setState({
                                "email": mobNumber,
                                "name": "New user",
                                "ProspectStage": res.data[0].prospectStage,
                                "mx_Lead_Status": res.data[0].mx_Lead_Status,
                                "mx_Status": res.data[0].mx_Status
                            }));
                            localStorage.setItem('userlogin', true);
                            localStorage.setItem('email', mobNumber);
                            localStorage.setItem('ProspectStage', res.data[0].prospectStage);
                            localStorage.setItem('mx_Lead_Status', res.data[0].mx_Lead_Status);
                            localStorage.setItem('mx_Status', res.data[0].mx_Status);
                            localStorage.setItem('name', "New user");
                            localStorage.setItem('token', "jhjsdhjhjhd");
                            setotpfieldenable(false);
                            setMobNumber('');
                            TrackApi(payloadData);
                            window.open('https://online.moneysukh.com');
                        } else {
                            axios.post(`${ApiUrlDomain}/signupnewuser`, { Mobile: mobNumber, mx_Vendor_Unique_Id: res.data[0].mx_Vendor_Unique_Id }).then((resn) => {
                                dispatch(setState({
                                    "email": mobNumber,
                                    "name": "New user",
                                    "ProspectStage": res.data[0].prospectStage,
                                    "mx_Lead_Status": res.data[0].mx_Lead_Status,
                                    "mx_Status": res.data[0].mx_Status
                                }));
                                localStorage.setItem('userlogin', true);
                                localStorage.setItem('email', mobNumber);
                                localStorage.setItem('ProspectStage', res.data[0].prospectStage);
                                localStorage.setItem('mx_Lead_Status', res.data[0].mx_Lead_Status);
                                localStorage.setItem('mx_Status', res.data[0].mx_Status);
                                localStorage.setItem('name', "New user");
                                localStorage.setItem('token', "jhjsdhjhjhd");
                                setotpfieldenable(false);
                                setMobNumber('');
                                if (resn && resn.data && resn.data.uniqueid) {
                                    axios.post(`${ApiUrlDomain}/lsqupdate`, {
                                        "LeadId": leadId,
                                        "mx_Vendor_Unique_Id": resn.data.uniqueid
                                    }).then((tt) => {

                                    }).catch((errd) => {
                                        console.log(errd);
                                    })
                                }
                                let redirecturlsignup = document.createElement('a');
                                redirecturlsignup.href = resn.data.data[0].url;
                                redirecturlsignup.target = '_blank';
                                redirecturlsignup.style.display = 'none';
                                document.body.appendChild(redirecturlsignup);
                                redirecturlsignup.click();
                                document.body.removeChild(redirecturlsignup);
                                TrackApi(payloadData);
                            }).catch((error) => {
                                dispatch(setState({
                                    "email": mobNumber,
                                    "name": "New user",
                                    "ProspectStage": res.data[0].prospectStage,
                                    "mx_Lead_Status": res.data[0].mx_Lead_Status,
                                    "mx_Status": res.data[0].mx_Status
                                }));
                                localStorage.setItem('userlogin', true);
                                localStorage.setItem('email', mobNumber);
                                localStorage.setItem('ProspectStage', res.data[0].prospectStage);
                                localStorage.setItem('mx_Lead_Status', res.data[0].mx_Lead_Status);
                                localStorage.setItem('mx_Status', res.data[0].mx_Status);
                                localStorage.setItem('name', "New user");
                                localStorage.setItem('token', "jhjsdhjhjhd");
                                setotpfieldenable(false);
                                setMobNumber('');
                                let redirecturlsignup = document.createElement('a');
                                redirecturlsignup.href = "https://kyc.moneysukh.com";
                                redirecturlsignup.target = '_blank';
                                redirecturlsignup.style.display = 'none';
                                document.body.appendChild(redirecturlsignup);
                                redirecturlsignup.click();
                                document.body.removeChild(redirecturlsignup);
                                TrackApi(payloadData);
                                console.log(error);
                            })
                        }
                    } else {
                        axios.post(`${ApiUrlDomain}/signupnewuser`, { Mobile: mobNumber, mx_Vendor_Unique_Id: "" }).then((resurl) => {
                            dispatch(setState({
                                "email": mobNumber,
                                "name": "New user"
                            }));
                            localStorage.setItem('userlogin', true);
                            localStorage.setItem('email', mobNumber);
                            localStorage.setItem('name', "New user");
                            localStorage.setItem('token', "jhjsdhjhjhd");
                            setotpfieldenable(false);
                            setMobNumber('');
                            let redirecturlsignup = document.createElement('a');
                            redirecturlsignup.href = resurl.data.data[0].url;
                            redirecturlsignup.target = '_blank';
                            redirecturlsignup.style.display = 'none';
                            document.body.appendChild(redirecturlsignup);
                            redirecturlsignup.click();
                            document.body.removeChild(redirecturlsignup);
                            // lead creat api
                            let bodydataleadapi = [
                                {
                                    "Attribute": "EmailAddress",
                                    "Value": ""
                                }, {
                                    "Attribute": "Phone",
                                    "Value": mobNumber
                                }, {
                                    "Attribute": "mx_Primary_Email_ID",
                                    "Value": ""
                                }, {
                                    "Attribute": "SearchBy",
                                    "Value": "mx_Primary_Email_ID"
                                },
                                {
                                    "Attribute": "Source",
                                    "Value": "Website"
                                },
                                {
                                    "Attribute": "mx_Vendor_Unique_Id",
                                    "Value": resurl.data.uniqueid
                                },
                                {
                                    "Attribute": "mx_website_URL_React",
                                    "Value": window.location.href
                                }
                            ];
                            axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async (responelead) => {
                                console.log("uhhhhhh", responelead);
                                const leadId = responelead && responelead.data && responelead.data.leadId;
                                setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                                const payloadData = {
                                    "RelatedProspectId": leadId,
                                    "ActivityNote": "Your Activity Note",
                                    "mx_Custom_1": "Home",
                                    "mx_Custom_2": "Your Activity Note",
                                    "mx_CustomObject_81": window.location.href
                                }
                                TrackApi(payloadData);
                            })
                        }).catch((error) => {
                            console.log(error);
                            dispatch(setState({
                                "email": mobNumber,
                                "name": "New user"
                            }));
                            localStorage.setItem('userlogin', true);
                            localStorage.setItem('email', mobNumber);
                            localStorage.setItem('name', "New user");
                            localStorage.setItem('token', "jhjsdhjhjhd");
                            setotpfieldenable(false);
                            setMobNumber('');
                            let redirecturlsignup = document.createElement('a');
                            redirecturlsignup.href = 'https://kyc.moneysukh.com';
                            redirecturlsignup.target = '_blank';
                            redirecturlsignup.style.display = 'none';
                            document.body.appendChild(redirecturlsignup);
                            redirecturlsignup.click();
                            document.body.removeChild(redirecturlsignup);
                            // lead creat api
                            let bodydataleadapi = [
                                {
                                    "Attribute": "EmailAddress",
                                    "Value": ""
                                }, {
                                    "Attribute": "Phone",
                                    "Value": mobNumber
                                }, {
                                    "Attribute": "mx_Primary_Email_ID",
                                    "Value": ""
                                }, {
                                    "Attribute": "SearchBy",
                                    "Value": "mx_Primary_Email_ID"
                                },
                                {
                                    "Attribute": "Source",
                                    "Value": "Website"
                                },
                                {
                                    "Attribute": "mx_Vendor_Unique_Id",
                                    "Value": ""
                                },
                                {
                                    "Attribute": "mx_website_URL_React",
                                    "Value": window.location.href
                                }
                            ];
                            axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async (responelead) => {
                                console.log("uhhhhhh", responelead);
                                const leadId = responelead && responelead.data && responelead.data.leadId;
                                setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                                const payloadData = {
                                    "RelatedProspectId": leadId,
                                    "ActivityNote": "Your Activity Note",
                                    "mx_Custom_1": "Home",
                                    "mx_Custom_2": "Your Activity Note",
                                    "mx_CustomObject_81": window.location.href
                                }
                                TrackApi(payloadData);
                            })
                        })
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else if (res.data == 'Invalid OTP') {
                Swal.fire(`Invalid OTP Please Enter Correct Otp`);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    return (
        <>
            <div className="ipodetails-page py-4 py-lg-5">
                <div className="container">
                    <section class="ipodetailsbreadcrum-section">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                <li><a href="/market/ipo">IPO</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                <li>Forthcoming IPO</li>
                            </ol>
                        </nav>
                    </section>

                    <section class="ipodetails-section">
                        <div class="ipodetails-wrapper">
                            <div className="ipodetails-left">
                                <div className="ipodetails-profile">
                                    <div className="ipodetails-imgprofile"><img src={ipoprofileimg}></img> </div>
                                    <div className="ipodetails-textprofile"><h2> {comanyname} {/*KSH International IPO*/}</h2></div>
                                </div>
                                <div className="ipodetails-status">
                                    <div className="ipodetailsstatus-imgprofile">
                                        <ul>
                                            <li>Status: <span>Live</span></li>
                                            <li>RHP <a href="#" title="KSH International" onClick={downloadPdf}  ><span className="ipodetails-pdficon"><img src={ipopdfimg}></img></span></a></li>
                                        </ul>
                                    </div>
                                    <div className="ipodetailsstatus-textpanel">
                                        <div className="ipodetailsstatus-text">
                                            ₹ 14,235<span><small className="px-1"><i>/</i></small> 39 shares</span>
                                            <p>Minimum Investment</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="ipodetails-infogrid">
                                    <h2>{comanyname} IPO</h2>
                                    <ul id="ipolist">
                                        {items.map((item, index) => (
                                            <li key={index} className={`list-box ${activeIndex === index ? "active" : ""}`}>
                                                <p>{item.data}  <strong>{item.value}</strong></p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="ipodetails-right">
                                <div className="ipodetails-rightinner">
                                    <p class="applyipo-heading">Open Free Demat Account</p>
                                    <div className="applyipo-form">
                                        <form className="maincta_form">
                                            <div class="input-group mb-3 mb-md-4">
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text">+91</div>
                                                </div>
                                                <input type="number" class="form-control" id="EnterMobileNumber" placeholder="Mobile number" onChange={handleNewUserMobileNumber} value={mobNumber} max={10} />
                                            </div>

                                            <div class="inputctaopt_grid">
                                                <div class="input-group mb-2">
                                                    <div className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowOtp(!showOtp)}>{showOtp ? Eye : EyeSlash}</div>
                                                    <div class="inputctaopt_group form-control">
                                                        <div className="inputctaopt"> <input size="1" type={showOtp ? "text" : "password"} className={`form-control`} onChange={(e) => setotpis1(e.target.value)} value={otpis1} id="otp1" maxlength="1" autocomplete="off" /></div>
                                                        <div className="inputctaopt"> <input size="1" type={showOtp ? "text" : "password"} className={`form-control`} onChange={(e) => setotpis2(e.target.value)} value={otpis2} id="otp2" maxlength="1" autocomplete="off" /></div>
                                                        <div className="inputctaopt"> <input size="1" type={showOtp ? "text" : "password"} className={`form-control`} onChange={(e) => setotpis3(e.target.value)} value={otpis3} id="otp3" maxlength="1" autocomplete="off" /></div>
                                                        <div className="inputctaopt"> <input size="1" type={showOtp ? "text" : "password"} className={`form-control`} onChange={(e) => setotpis4(e.target.value)} value={otpis4} id="otp4" maxlength="1" autocomplete="off" /></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="applyipoform-btn">
                                                {newmobotpverify == true ? verifyloader == true ? <button type="button" class="btn btn-primary w-100">Wait..</button> : <button type="button" class="btn btn-primary w-100" onClick={(e) => NewsignFlow(e)}>Verify</button> : <button type="button" class="btn btn-primary w-100" onClick={() => loginwithemailnewflow()}>Apply Now</button>}
                                            </div>
                                        </form>
                                    </div>
                                    <p class="ipotnc-text">By proceeding, you agree to all <a href="/TermsCondition">T&amp;C*</a></p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="ipodetails-timelinesection">
                        <h2>{comanyname} Timeline</h2>
                        <div className="ipodetails-timelinewrapper">
                            {currentTableData && currentTableData.map(
                                ({ LEADMGR, lname, regadd1, regadd2, regdist, regpin, regstate, tel1, fax1, email, internet, object, CreditofsharestoDemataccountDate, RefundDate, AllotmentDate, OPENDATE, CLOSDATE, listdate, APPNMONEY2, APPNMONEY1, PROJCOST, publiss1, TOT_EQTY, ISSUEPRICE, ALOTMONEY1, ALOTMONEY2, MULTIPLES, MIN_APPLN }) => (
                                    <>
                                        <div className="ipodetails-timelinetabslider">
                                            <ul className="ipodetails-timelinetabsteps">
                                                <li className={isPastOrPresent(OPENDATE) ? 'active' : ''}>
                                                    <p>Bidding starts</p>
                                                    <span>{formatDate(OPENDATE)}</span>
                                                </li>
                                                <li className={isPastOrPresent(CLOSDATE) ? 'active' : ''}>
                                                    <p>Bidding ends</p>
                                                    <span>{formatDate(CLOSDATE)}</span>
                                                </li>
                                                <li className={isPastOrPresent(AllotmentDate) ? 'active' : ''}>
                                                    <p>Allotment finalisation</p>
                                                    <span>{formatDate(AllotmentDate)}</span>
                                                </li>
                                                <li className={isPastOrPresent(RefundDate) ? 'active' : ''}>
                                                    <p>Refund initiation</p>
                                                    <span>{formatDate(RefundDate)}</span>
                                                </li>
                                                <li className={isPastOrPresent(CreditofsharestoDemataccountDate) ? 'active' : ''}>
                                                    <p>Demat transfer</p>
                                                    <span>{formatDate(CreditofsharestoDemataccountDate)}</span>
                                                </li>
                                                <li className={isPastOrPresent(listdate) ? 'active' : ''}>
                                                    <p>Listing</p>
                                                    <span>{formatDate(listdate)}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </>))}
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}

export default IpoDetailsNew;
